// Vendor libraries
import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class IconModule {
}
IconModule.ɵfac = function IconModule_Factory(t) { return new (t || IconModule)(); };
IconModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IconModule });
IconModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
